const React = require("react");
const filter = require("mn-utils/filter");
const changeProviderProvider = require("mn-utils/changeProviderProvider");
const trim = require("mn-utils/trim");
const isEmail = require("mn-utils/isEmail");
const noop = require("mn-utils/noop");

const {openPopupWindow, openPopupInfo} = require("../../../../../emitters/popup");
const {apiV2RefundEdit, apiV2GetRefundDetails} = require("../../../../../api/merchant/refunds");
const Popup = require("../../../../dumb/Popup/B");
const TextField = require("../../../../dumb/TextField/A");
const {apiV2GetTransactionDetails} = require("../../../../../api/merchant/transactions");
const {Grid, Box} = require("@material-ui/core");
const {BtnBlueFilled, BtnBlueOutlined} = require("../../../../helpers/Buttons");

module.exports = (refundData, update) => {
  openPopupWindow((setPopupState, popup, onMount) => {
    const {
      close,
    } = popup;

    onMount(() => {
      setPopupState({
        loading: true
      });

      apiV2GetRefundDetails({
        id: refundData.refundId,
      }).then(({email, name}) => {
        setPopupState({
          email,
          name: '-',
          loading: false
        })
      })
    })

    const changeProvider = changeProviderProvider(setPopupState);
    const handleChangeEmail = changeProvider('email');
    const handleChangeName = changeProvider('name');

    return (stateOfPopup) => {
      const {name, email, clicked} = stateOfPopup;

      const _name = trim(name);
      const _email = trim(email);

      const invalidName = !_name;
      const invalidEmail = !isEmail(_email);

      const disabled = invalidEmail;

      const handleSubmit = () => {
        if (disabled) {
          setPopupState({clicked: true});
          return;
        }

        apiV2RefundEdit({
          refund_id: refundData.refundId,
          email,
          name: ''
        }).then(update).then(() => {
          close();
          setTimeout(() => {
            openPopupInfo([`${refundData.refundId} has been updated`]);
          }, 100);
        });
      }

      return (
        <Popup caption={`Edit refund ${refundData.refundId}`}>
          <Box mt="3.5rem">
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <TextField
                  label="Customer email"
                  value={email || ""}
                  onChange={handleChangeEmail}
                  error={clicked && invalidEmail}
                  helperText={_email ? 'Invalid email' : 'Obligatory field'}
                  maxLength={250}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  label="Customer name"
                  value={name || ""}
                  onChange={handleChangeName}
                  error={clicked && invalidName}
                  helperText="Obligatory field"
                  maxLength={250}
                  disabled
                />
              </Grid>
            </Grid>
          </Box>
          <Box maxWidth="60rem" mt="3.5rem">
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <BtnBlueFilled
                  disabled={clicked && disabled}
                  onClick={handleSubmit}
                >
                  Save
                </BtnBlueFilled>
              </Grid>
              <Grid item md={6} xs={12}>
                <BtnBlueOutlined onClick={close}>
                  Close
                </BtnBlueOutlined>
              </Grid>
            </Grid>
          </Box>
        </Popup>
      );
    };
  });
};
